/**
 * Composable pour la gestion du timer d'appel
 * Limite: 100 lignes max
 */

import { ref } from 'vue'

export function useCallTimer(callStartTime, callDuration) {
  let timerInterval = null

  const startTimer = () => {
    if (timerInterval) clearInterval(timerInterval)
    
    timerInterval = setInterval(() => {
      if (callStartTime.value) {
        callDuration.value = Math.floor((Date.now() - callStartTime.value) / 1000)
      }
    }, 1000)
    
    return timerInterval
  }

  const stopTimer = () => {
    if (timerInterval) {
      clearInterval(timerInterval)
      timerInterval = null
    }
  }

  const resetTimer = () => {
    stopTimer()
    callStartTime.value = null
    callDuration.value = 0
  }

  return {
    startTimer,
    stopTimer,
    resetTimer,
    getTimerInterval: () => timerInterval
  }
}
